// eslint-disable-next-line import/prefer-default-export
export const LOCALES = {
  SE: 'sv',
  EN: 'en',
  TEST: 'XX',
};
